export default [
  {
    text: 'Pendente',
    value: 'AGUARDANDO_ENVIO',
    color: '#FFF3E0',
    textColor: '#FFA726',
  },
  {
    text: 'Rascunho',
    value: 'RASCUNHO',
    color: '#E1F5FE',
    textColor: '#80D8FF',
  },
  {
    text: 'Enviada',
    value: 'ENVIADA',
    color: '#E8F5E9',
    textColor: '#66BB6A',
  },
  {
    text: 'Agendada',
    value: 'AGENDADA',
    color: '#FFF9C4',
    textColor: '#F57F17',
  },
];
